import React from "react";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";

import { P } from "../../atoms/Texts";
import { DarkFormField } from "../../atoms/Inputs";
import searchSmallIcon from "../../../assets/images/search-small.svg";

export const SearchMember = ({ setSearchedUser }) => {
  const {
    register,
    formState: { errors },
  } = useForm();

  return (
    <div className="w-full">
      <div className="w-full mx-auto">
        <form>
          <div>
            <DarkFormField
              type="search"
              id="email"
              name="email"
              w="135px"
              placeholder="john@doe.com"
              icon={searchSmallIcon}
              // iconClick={handleSubmit(onSearchUserByEmail)}
              label="Work Email"
              className="w-full"
              {...register("email", {
                required: "Enter member's email",
              })}
            />
            <ErrorMessage
              errors={errors}
              name="email"
              as={<P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm" />}
            >
              {({ messages }) =>
                messages &&
                Object.entries(messages).map(([type, message]) => (
                  <P key={type}>{message}</P>
                ))
              }
            </ErrorMessage>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SearchMember;
